
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalCoinHistory from '@/components/templates/ModalCoinHistory.vue'
import { CoinHistory } from '@/models/CoinHistory'
import { UserCoinsApi } from '@/api/methods/UserCoinsApi'

/**
 * 生徒獲得コイン履歴モーダル
 */
@Component({
  components: {
    ModalCoinHistory,
  },
})
export default class ModalStudentCoinHistory extends Vue {
  /** コイン履歴モーダル */
  @Ref()
  modalCoinHistory!: ModalCoinHistory

  /** コイン獲得履歴の最大取得件数 */
  private readonly MAX_COUNT_HISTORIES = 100

  /** コイン獲得履歴一覧 */
  private coinHistoryList: CoinHistory[] = []

  /**
   * コイン獲得履歴一覧を取得し、モーダルを開く
   */
  public async show(): Promise<void> {
    this.$loading.start()

    const user = this.$appCookies.authStudent.get()

    // コイン獲得履歴取得
    const histories = await UserCoinsApi.getUserCoinHistories(user.userId, this.MAX_COUNT_HISTORIES)

    // Frontの型に詰め替え
    this.coinHistoryList = histories.map((history) => {
      return {
        score: history.score,
        date: new Date(history.date * 1000),
      }
    })

    this.$loading.complete()

    this.modalCoinHistory.show()
  }
}
